export default "__VITE_ASSET__D3LZ2Ejb__"